import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CommodityService } from '../_services';
import * as CommodityActions from '../_actions/commodity';

@Injectable({
  providedIn: 'root',
})
export class CommodityEffects {
  loadCommodities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommodityActions.loadCommodities),
      mergeMap(() =>
        this.commodityService.getCommodities().pipe(
          map((commodities) => CommodityActions.loadCommoditiesSuccess({ commodities })),
          catchError((error) => of(CommodityActions.loadCommoditiesFailure({ error })))
        )
      )
    )
  );

  addCommodity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommodityActions.addCommodity),
      mergeMap(({ commodity }) =>
        this.commodityService.saveCommodity(commodity).pipe(
          map((savedCommodity) =>
            CommodityActions.addCommoditySuccess({ commodity: savedCommodity })
          ),
          catchError((error) => of(CommodityActions.addCommodityFailure({ error })))
        )
      )
    )
  );

  updateCommodity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommodityActions.updateCommodity),
      mergeMap(({ commodity }) =>
        this.commodityService.saveCommodity(commodity).pipe(
          map((updatedCommodity) =>
            CommodityActions.updateCommoditySuccess({ commodity: updatedCommodity })
          ),
          catchError((error) => of(CommodityActions.updateCommodityFailure({ error })))
        )
      )
    )
  );

  deleteCommodity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommodityActions.deleteCommodity),
      mergeMap(({ id }) =>
        this.commodityService.deleteCommodity(id).pipe(
          map(() => CommodityActions.deleteCommoditySuccess({ id })),
          catchError((error) => of(CommodityActions.deleteCommodityFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private commodityService: CommodityService
  ) {}
}
